import EnergyHeader from "./Header";
import "./index.css";
import { useState, useEffect } from "react";
import MainEnergyContents from "./MainEnergyContents";
import HomeProducedContents from "./HomeProducedEnergyContents";
import SymbioticEnergyContents from "./SymbioticEnergyContents";
import { ShowHide } from "../components/ShowHideCompany";
import { getMainEnergyList } from "../../../../apis/Business/EnergyApi";
import EPRBox from "../components/EPRBox";

const EnergyComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  const [totalObjEnergy, setTotalObjEnergy] = useState([]);
  const [totalEnergy, setTotalEnergy] = useState([]);
  const [systemBoundaryEnergy, setSystemBoundaryEnergy] = useState("");

  useEffect(() => {
    getMainEnergyList({
      businessId: businessId,
      setTotalObj: setTotalObjEnergy,
      setTotalEnergy: setTotalEnergy,
      setSystemBoundaryEnergy: setSystemBoundaryEnergy,
    });
  }, [businessId]);
  return (
    <div className="energy-container" id="energy-id">
      <EnergyHeader
        businessId={businessId}
        show={show}
        totalObjEnergy={totalObjEnergy}
        totalEnergy={totalEnergy}
      />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <EPRBox
          businessId={businessId}
          mainBusinessId={mainBusinessId}
          category={"Energy"}
        />
      )}
      {show && (
        <MainEnergyContents
          businessId={businessId}
          systemBoundaryProps={{
            systemBoundary: systemBoundaryEnergy,
            setSystemBoundary: setSystemBoundaryEnergy,
            businessId: businessId,
            totalObjCategory: totalObjEnergy.category_name,
          }}
        />
      )}
      {show && <HomeProducedContents businessId={businessId} />}
      {show && <SymbioticEnergyContents businessId={businessId} />}
    </div>
  );
};

export default EnergyComponent;
